import type { CommandHandler } from '../types';

export const changeCompanyBankAccountCommandHandler: CommandHandler = (command, context) => {
  const invoiceIds = Array.from(context.selectedRows ?? [])
    .map((id) => Number(id))
    .filter((id) => Number.isInteger(id) && id > 0);

  if (invoiceIds.length === 0) {
    return {
      success: false,
      error: 'Please select at least one invoice.',
    };
  }

  if (!context.openCompanyBankAccountPicker) {
    return {
      success: false,
      error: 'Change bank account dialog is not available.',
    };
  }

  const targetFieldName = command.settings?.trim();
  if (!targetFieldName) {
    return {
      success: false,
      error: 'Target field is not configured for this command.',
    };
  }

  context.openCompanyBankAccountPicker(command, invoiceIds, targetFieldName);
  return { success: true };
};
